/**
 * Core Page
 */
export const GA_TOYOTA_FOR_YOU_CORE_PAGE = "Toyota For You - core page";
export const GA_TOYOTA_FOR_YOU_CP = "toyota_for_you_cp";

/**
 * Configurator
 */
export const GA_TOYOTA_FOR_YOU_CONFIGURATION = "Toyota For You - vehicle configuration";
export const GA_TOYOTA_FOR_YOU_CUSTOMISE = "Toyota For You - customise";
export const GA_LOAD_CONFIGURATION = "load configuration";
export const GA_VEHICLE_CONFIGURATION = "vehicle configuration";
export const GA_VEHICLE_CUSTOMISE = "vehicle - customise";
export const GA_VEHICLE_GRADE = "vehicle - grade";

/**
 * Compare
 */
export const GA_TOYOTA_FOR_YOU_COMPARE_GRADES =
  "Toyota For You - specifications compare grades";
export const GA_VEHICLE_COMPARE = "vehicle - grade comparison";

/**
 * Charging
 */
export const GA_TOYOTA_FOR_YOU_CHARGING = "Toyota For You - charging";
export const GA_VEHICLE_CHARGING = "vehicle - charging";

/**
 * Next Steps
 */
export const GA_NEXT_STEPS = "Next steps";
export const GA_TOYOTA_FOR_YOU_NEXT_STEPS = "toyota_for_you_next_steps";
export const GA_TOYOTA_FOR_YOU_NEXT_STEPS_PAGE = "Toyota For You - next steps page";

/**
 * Features
 */
export const GA_TOYOTA_FOR_YOU_FEATURES = "Toyota For You - features";
export const GA_FEATURES = "features";
export const GA_FEATURES_DESIGN = "features - design";
export const GA_VEHICLE_FEATURES = "vehicle - features";

/**
 * Finance
 */
export const GA_BUTTON_CONTINUE_TO_PAYMENT = "continue to payment";
export const GA_CONTINUE_TO_PAYMENT = "continue_to_payment";
export const GA_TOYOTA_FINANCE = "toyota finance";

/**
 * Overlay Pages
 */
export const GA_TOYOTA_FOR_YOU_OVERLAY = "toyota_for_you_overlay";
export const GA_TOYOTA_FOR_YOU_OVERLAY_PAGE = "Toyota For You - overlay page";

/**
 * Interact 3D
 */
export const GA_INTERACT_3D_EXTERIOR_PAN = "Exterior - Pan";
export const GA_INTERACT_3D_VEHICLE_EXTERIOR_PAN = "vehicle - Exterior - Pan";
export const GA_INTERACT_3D_TOYOTA_CONNECTED_SERVICES = "toyota connected services";

/**
 * Miscellaneous, buttons, etc...
 */
export const GA_AT = "AT";
export const GA_DEALER_INFORMATION = "dealer information";
export const GA_OVERVIEW = "overview";
export const GA_ACCORDION_EXPAND = "expand";
export const GA_ACCORDION_COLLAPSE = "collapse";

/**
 * Events, these are mapped to useGa --> triggerGAEvent
 */
export enum GaEvent {
  ACCESS_CODE = "your_unique_access_code",
  ACCORDION_CLICK = "accordion_click",
  ADJUST_LEASE_OPTION = "adjust_lease_options",
  BOOK_TEST_DRIVE = "book_test_drive",
  BUTTON_CLICKS = "button_clicks",
  CLICK_TO_CALL = "click_to_call",
  CONFIGURATOR_SELECT_GRADE = "select_grade",
  CONFIGURATOR_SELECT_TAB = "select_tab",
  CONFIGURATOR_SELECT_ACCESSORY = "select_accessory",
  CONFIGURATOR_SELECT_COLOUR_TRIM = "select_colour_trim",
  CONFIGURATOR_INTERACT_3D = "interact_3d",
  COPY_VEHICLE_CONFIGURATION_LINK = "copy_vehicle_link",
  DEALER_NEXT_STEPS = "dealer_next_steps",
  DOWNLOAD_BROCHURE_PDF = "download_brochure_pdf",
  DOWNLOAD_FULL_SPEC_SHEET = "download_full_spec_sheet",
  EMAIL_DEALER = "email_dealer",
  ERROR_MESSAGE = "error_message",
  LAUNCH_AR = "launch_ar",
  LAUNCH_AR_AVAILABILITY = "launch_ar_availability",
  LOAD_VEHICLE_CONFIG_BY_PIN = "load_vehicle_configuration_by_pin",
  PAGE_VIEW = "page_view",
  SAVE_VEHICLE_CONFIGURATION = "save_configuration",
  SPEC_COMPARE_GRADES = "compare_grades",
  SPEC_SELECT_GRADE = "select_grade_spec",
  SUBMIT_SAVE_VEHICLE_FORM = "save_vehicle",
  TOYOTA_FOR_YOU_CORE_PAGE = "toyota_for_you_cp",
  VIEW_FEATURES = "view_features",
  VIEW_FINANCE_OPTIONS = "view_finance_options",
  VIEW_IN_AR = "view_in_ar",
  VIEW_SCREEN = "view_screen",
  VIEW_SPECS_AND_GRADES = "view_specs_and_grades",
  TR1_1 = "TR1.1",
  TR1_2 = "TR1.2",
  TR1_3 = "TR1.3",
  TR1_4 = "TR1.4",
  TR1_5 = "TR1.5",
  TR1_6 = "TR1.6",
  TR1_7 = "TR1.7",
  TR1_8 = "TR1.8",
  TR1_9 = "TR1.9",
  TR1_10 = "TR1.10",
  TR1_11 = "TR1.11",
  TR2_1 = "TR2.1",
  TR2_2 = "TR2.2",
  TR3_1 = "TR3.1",
  TR3_2 = "TR3.2",
  TR4_1 = "TR4.1",
  TR5_1 = "TR5.1",
  TR5_2 = "TR5.2",
  TR6_1 = "TR6.1",
  TR7_1 = "TR7.1",
  TR7_2 = "TR7.2",
  TR7_3 = "TR7.3",
  TR7_4 = "TR7.4",
  TR7_5 = "TR7.5",
  TR7_6 = "TR7.6",
  TR7_7 = "TR7.7",
  TR8_1 = "TR8.1",
  TR9_1 = "TR9.1",
  TR9_2 = "TR9.2",
  TR10_1 = "TR10.1",
  TR11_1 = "TR11.1",
  TR11_2 = "TR11.2",
}

/**
 * Data utton names to be mapped to instances of the gaDataButtonName data attribute
 */
export enum GaButtonName {
  ACCESS_CODE = "dealer information | your unique access code",
  BOOK_TEST_DRIVE = "dealer information | book a test drive",
  CALL_TO_ACTION = "call to action",
  CLICK_TO_CALL = "dealer information | click to call",
  EMAIL_DEALER = "dealer information | email dealer",
  DEALER_FINANCE = "dealer information | get my estimate",
  DEALER_NEXT_STEPS = "dealer information | next steps",
  DEALER_NOVATED_LEASE = "dealer information | learn more",
  DEALER_ORDER_ONLINE = "dealer information | order online",
  DOWNLOAD_FULL_SPEC_SHEET = "vehicle specifications | download full spec-sheet",
  FINANCE_OPTIONS = "dealer information | finance options",
  NAVBAR_ALL_VEHICLES = "sticky menu | all vehicles",
  NAVBAR_CUSTOMISE = "sticky menu | customise",
  NAVBAR_GALLERY = "sticky menu | gallery",
  NAVBAR_NEXT_STEPS = "sticky menu | next steps",
  NAVBAR_SHARE = "sticky menu | save and share",
  NAVBAR_VEHICLE_HOME = "vehicle configuration | back to vehicle home",
  NEXT_STEPS_ACCESS_CODE = "next steps | your unique access code",
  SAVE_AND_SHARE_ACCESS_CODE = "save and share | your unique access code",
  VIEW_FEATURES = "vehicle features | view features",
  VIEW_IN_AR_CONFIGURATOR = "vehicle configuration | view in ar",
  VIEW_IN_AR_FEATURES = "vehicle features | view in ar",
  VIEW_IN_AR_STICKY_MENU = "sticky menu | view in ar",
  VIEW_SPECS_AND_GRADES = "vehicle specifications | view specs & grades",
}

/**
 * Data section names to be mapped to instances of the gaSectionName data attribute
 */
export enum GaSectionName {
  DEALER_INFORMATION = "dealer information",
  FEATURES = "features",
  PRICING = "vehicle pricing",
  SAVE_AND_SHARE = "save and share",
  SPECIFICATIONS = "vehicle specifications",
  STICKY_MENU = "sticky menu",
  QUICK_LINKS = "quick links",
}
